import { useEffect } from "react";

export function useCmPublishSubmit({
  mutation,
  allModifiedRowKeys,
  selectedRows,
  cmEditedRows,
  setFeedbackByRow,
  setLoading,
  setSendState,
  setAlertState,
}) {
  useEffect(() => {
    const handler = (e) => {
      const isPublishing = sessionStorage.getItem("cm-publish-loading") === "true";
      if (!isPublishing) return;
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, []);

  const submit = () => {
    const payload = allModifiedRowKeys
      .filter((id) => selectedRows[id])
      .map((id) => {
        const row = cmEditedRows[id];
        return {
          id,
          dailyBudget:
            row?.dailyBudget?.value ?? row?.dailyBudget,
          targetRoas:
            row?.targetRoas?.value ?? row?.targetRoas,
        };
      });

    sessionStorage.setItem("cm-publish-loading", "true");
    setLoading(true);

    mutation.mutate(payload, {
      onSuccess: (response = []) => {
        const feedbackMap = {};
        if (Array.isArray(response)) {
          response.forEach((result) => {
            feedbackMap[result.id] = {
              success: !result.isError,
              message: result.message,
            };
          });
        } else {
          payload.forEach(({ id }) => {
            feedbackMap[id] = { success: true };
          });
        }
        setFeedbackByRow(feedbackMap);
        setSendState("success");
      },

      onError: () => {
        if (setAlertState) {
          setAlertState({
            open: true,
            message: `Hubo un problema técnico al conectar con el servidor. ${payload.length} cambio(s) quedaron pendientes.`,
            title: "No se pudo completar la publicación",
            errors: [],
            severity: "error",
          });
        }
        setSendState("error");
      },

      onSettled: () => {
        sessionStorage.removeItem("cm-publish-loading");
        setLoading(false);
      },
    });
  };

  return submit;
}
